import icons from "./uiIcons.json";
import styles from "./PartnerMap.module.scss";

const MARKUP = icons as Record<string, string>;

export const hasUiIcon = (name: string): boolean => Object.prototype.hasOwnProperty.call(MARKUP, name);

/** One of the page's own icons (uiIcons.json), drawn as an svg that takes its size from the CSS of where it sits. The markup is our own static data, never user input. */
export const UiIcon = ({ name }: { name: string }) => (
	<span className={styles.ic} aria-hidden="true" dangerouslySetInnerHTML={{ __html: MARKUP[name] ?? "" }} />
);
